// @ts-nocheck
import { createHandlerChainRunnerOptionalParameter, Handler } from "@toolkit/Modules/client-framework/HandlerCreator";

type HandlerType = Handler;

export const DispatchClearParameter: HandlerType = props => {
    props.dispatch({
        type: "Greif/Pages/TrailerTrackingV2/ClearParameter",
    });
};

export const chain = [DispatchClearParameter];

const clearParameter = createHandlerChainRunnerOptionalParameter(chain, {}, "ClearParameter");
export default clearParameter;
